import { render, staticRenderFns } from "./scroll-table.vue?vue&type=template&id=1dafa99a&scoped=true&"
import script from "./scroll-table.vue?vue&type=script&lang=js&"
export * from "./scroll-table.vue?vue&type=script&lang=js&"
import style0 from "./scroll-table.vue?vue&type=style&index=0&id=1dafa99a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafa99a",
  null
  
)

export default component.exports